import Joi from 'joi';
import { COURSE_CONTENT } from './CourseContent/course.content.types';

export const courseSubjectVideoSchema = Joi.object().keys({
  contentType: Joi.string().required().equal(COURSE_CONTENT.VIDEO),
  content: Joi.object(),
});
export const isCourseSubjectVideo = (object: any): object is boolean =>
  !!courseSubjectVideoSchema.validate(object).error;
